import DropdownFilter from './dropdown-filter';
import type { CalendarFilters } from './filter-bar';

const options = {
  upcoming: 'Upcoming',
  recent: 'Recently Added',
  rsvp: 'My RSVPs',
  managed: 'My Hosting',
  drafts: 'My Drafts',
  past: 'Past',
};

type Props = {
  value?: CalendarFilters['filter'];
  onChange: (attribute: string, value: unknown) => void;
};

const CalendarPrimaryFilter = ({ value, onChange }: Props) => {
  return (
    <DropdownFilter
      attribute="filter"
      options={options}
      value={value}
      onChange={onChange}
    />
  );
};

export default CalendarPrimaryFilter;
